module.exports = __webpack_public_path__ + "static/media/portfolio1 (37).b6160608.jpeg";